import {IntersectionObserverController} from "./lib/Intersection-observer-controller";
import {scrollbarCssVars} from "./lib/scrollbar-css";
import {initHeader} from "./header";
import {initAccordians} from "./lib/accordian";
import {fromEvent} from "rxjs";
import {tap} from "rxjs/operators";
import {damnXoverflow} from "./lib/x-overflow";
import {Scroller} from "./lib/my-scroll/my-scroll";
import {VimeoInit} from "./vimeo";
import {initBookingPanel, showBookingPanel} from "./booking-panel";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.cjs'
import {initMapItemsCarouselSwiper} from "./lib/map-items-carousel--swiper";
import {initImageCarouselSwiper} from "./lib/image-carousel--swiper";
import baguetteBox from 'baguettebox.js';

jQuery(document).ready( () => {
    initPage();
    console.log('INIT PAGE');
    // damnXoverflow();
});


const initPage = () => {
    // console.log('init page Mainsds');
    let template;
    let $body  = jQuery('body');
    if( $body.hasClass('single-post')){
        template = 'single-post';
    }else if( $body.hasClass('single-activity')){
        template = 'single-activity';
    }else{

        template = $body.attr('class').split(/\s+/).find(
            c => c.startsWith('page-template-') &&  !c.endsWith('-php') && c != 'page-template-page-templates');
        template = template ? template.substring(14) : 'notDefined';

    }
    console.log('PAGE TEMPLATE IS: ',  template);
    initTemplate[template] ? initTemplate[template]() : initTemplate['notDefined']();
    //initSlidingThings();

};

const compatIntersectionObserver = () =>{

    if(!('IntersectionObserver'  in window)){
        console.log('No intersection Observer');
        jQuery('.observe').addClass('show');
        //return;
    }else{
        (IntersectionObserverController.
        createSelectorsObservable('.observe', 0.1)).subscribe();
    }
}

const commonStartRoutine = (headerConfig: {opaqueAtTop: boolean, logoAtTop: boolean} = {
    opaqueAtTop: true, logoAtTop: true}) => {


    scrollbarCssVars();
    compatIntersectionObserver();
    /*(IntersectionObserverController.
    createSelectorsObservable('.observe', 0.1)).subscribe();*/
    initAccordians();
    initHeader(headerConfig);
    scrollingButtons();
    initBookingPanel();
    baguetteBox.run('section.gallery');
    propertyCardButton();

};

const propertyCardButton = () =>{
    fromEvent(jQuery('.property-card-c0 button'), 'click').pipe(
        tap(e => {
            e.preventDefault();
            showBookingPanel();
        }),

    ).subscribe()
}
const defaultInit = () =>{
    commonStartRoutine();
};

const homeInit = () => {
    commonStartRoutine({opaqueAtTop: false, logoAtTop: false});
   VimeoInit(jQuery('#vimeoplayer'));
};

const activitiesListPageInit = ()=>{
    console.log('ACTIVITIES INIT');
    commonStartRoutine({opaqueAtTop:false, logoAtTop: true});
    const tips: any = tippy('.map-point', {
        arrow: true,
        animation: 'scale',
        theme: 'custom',
        zIndex: 14,
        hideOnClick: false,
        trigger: 'manual'
    });
    const nymetPin: any = tippy('.nymetwood-pin', {
        arrow: true,
        // animation: 'scale',
        theme: 'nymet',
        zIndex: 9,
        hideOnClick: false,
        trigger: 'click'
    });

    // console.log(tips);
    // //setTimeout(()=>  tips.map((t:any) => t.show()), 400);
    setTimeout(()=>  nymetPin.map((t:any) => t.show()), 400);
    initMapItemsCarouselSwiper('.activities-swiper', '.map-items-c0', tips)


}

const blogPageInit = () => {
    console.log('BLOG PAGE');
    commonStartRoutine({opaqueAtTop:false, logoAtTop: true});
}

const propertySinglePageInit = () =>{
    commonStartRoutine({opaqueAtTop:false, logoAtTop: true});
    initImageCarouselSwiper('.img-swiper');
}

const cabinsPageInit = () => {
    commonStartRoutine({opaqueAtTop:false, logoAtTop: true});
    initImageCarouselSwiper('.img-swiper')
}

const initTemplate  = {
    //'page-faqs': defaultInit,
    'page-home': homeInit,
    'page-activities' : activitiesListPageInit,
    'page-single-property': propertySinglePageInit,
    'page-blog': blogPageInit,
    'page-treehouses': cabinsPageInit,
    'single-post': () => {commonStartRoutine({opaqueAtTop: false, logoAtTop: true})},
    'single-activity': () => {commonStartRoutine({opaqueAtTop: false, logoAtTop: true})},
    'page-contact': () => {commonStartRoutine({opaqueAtTop: false, logoAtTop: true})},
    'page-about': () => {commonStartRoutine({opaqueAtTop: false, logoAtTop: true})},
    'notDefined': defaultInit
};


const scrollingButtons = ( ) => {

    /*const listenClick = (el, target) => {

        fromEvent(el, 'click').pipe(
            //tap(_ => console.log('clicked shop')),
            tap( e => new Scroller().scrollTo(target.offset().top - 80,null, 900 ))
        ).subscribe();
    }

    let shop = jQuery('.page-template-custom-filter-grid-page-shop .page-hero .themed-link');
    if(shop.length > 0){
        // console.log('isten click', shop);
        listenClick(shop, jQuery('.site-main'));
    }
    let rituals = jQuery('.page-template-custom-filter-grid-page-rituals .page-hero .themed-link');
    //console.log(shop);
    if(rituals.length > 0){
        //console.log('isten click', shop);
        listenClick(rituals, jQuery('.after-hero'));
    }
*/
}